/**
 * Klaviyo Subscribe – handles forms with class
 * `aq-blog-subscribe-form__form` or `cm-subscribe__form`
 *
 * Each form must have:
 *   data-klaviyo-list  – Klaviyo list ID (set via Liquid)
 *   data-klaviyo-lang  – 'en' or 'fr' (set via Liquid)
 */

(function () {
  var COMPANY_ID = 'T5ekCT';
  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID;
  var REVISION = '2024-10-15';

  var SUCCESS_MESSAGES = {
    en: 'Thank you for subscribing!',
    fr: 'Merci pour votre inscription!'
  };

  document.querySelectorAll('.aq-blog-subscribe-form__form, .cm-subscribe__form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var listId = form.dataset.klaviyoList;
      var lang = form.dataset.klaviyoLang || 'en';

      var emailInput = form.querySelector('input[type="email"]');
      var nameInput = form.querySelector('input[name="contact[first_name]"]');

      if (!emailInput || !emailInput.value.trim()) return;

      var email = emailInput.value.trim();
      var firstName = nameInput ? nameInput.value.trim() : '';

      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) submitBtn.disabled = true;

      // Remove any previous message
      var existing = form.querySelector('.klaviyo-subscribe__message');
      if (existing) existing.remove();

      fetch(ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': REVISION
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Website Footer Signup',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    first_name: firstName,
                    properties: {
                      language: lang
                    }
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: 'list',
                  id: listId
                }
              }
            }
          }
        })
      })
        .then(function (res) {
          var msg = document.createElement('p');
          msg.className = 'cm-subscribe__message klaviyo-subscribe__message';

          if (res.ok || res.status === 202) {
            msg.classList.add('is-success');
            msg.setAttribute('role', 'status');
            msg.textContent = SUCCESS_MESSAGES[lang] || SUCCESS_MESSAGES.en;
            form.reset();
          } else {
            msg.classList.add('is-error');
            msg.setAttribute('role', 'alert');
            msg.textContent = lang === 'fr'
              ? 'Une erreur est survenue. Veuillez réessayer.'
              : 'Something went wrong. Please try again.';
          }

          form.appendChild(msg);
        })
        .catch(function () {
          var msg = document.createElement('p');
          msg.className = 'cm-subscribe__message klaviyo-subscribe__message is-error';
          msg.setAttribute('role', 'alert');
          msg.textContent = lang === 'fr'
            ? 'Une erreur est survenue. Veuillez réessayer.'
            : 'Something went wrong. Please try again.';
          form.appendChild(msg);
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  });
})();
